import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_BASE } from '../../config/env';
import { exportToExcel } from '../../utils/exportToExcel';
export default function CharacterModule({ activeFilter,activeModule, sdate, edate }) {
  const [stationRows, setStationRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    loadStationData();
  }, [activeModule,sdate]);

  async function loadStationData() {
    setLoading(true);
    setError('');
    try {
      const res = await axios.get(`${API_BASE}/dashboard`, {
        params: {
          type: activeModule,
          sdate: sdate,
          edate: edate
        }
      });
      if (res.data && res.data.stationRows && res.data.stationRows.length > 0) {
        setStationRows(res.data.stationRows);
        // console.log("res.data.stationRows ",res.data.stationRows);
      }
    } catch (e) {
      console.warn('Using default station reference data:', e.message);
    } finally {
      setLoading(false);
    }
  }


  // Highlight classes based on selected dropdown options (activeFilter)
  const getHighlightClass = (colName) => {
    if (!activeFilter) return '';
    const nameMap = {
      totalps: 'ps',
      totalliu: 'liu',
      totaldcrb: 'dcrb',
      totaldcp: 'dcp',
    };
    return nameMap[activeFilter] === colName ? 'highlight-column' : '';
  };

  function handleExcelExport() {
    const headers = [
      'Sr.No.',
      'Police Station',
      'Received',
      'Pending',
      'PS',
      'DCRB',
      'LIU',
      'DCP',
      'Own to Other',
      'Other to Own',
    ];
    const data = stationRows.map((r, i) => [
      i + 1,
      r.pre_station_name,
      r.request_count || 0,
      r.pending_count || r.c_remain || 0,
      r.pending_ps_count || r.c_station || 0,
      r.pending_dcrb_count || r.c_dcrb || 0,
      r.pending_liu_count || r.c_liu || 0,
      r.pending_dcp_count || r.c_dcp || 0,
      r.own_to_other || r.c_own_to_other || 0,
      r.other_to_own || r.c_other_to_own || 0,
    ]);
    const titleLabel = (activeModule?.charAt(0).toUpperCase() + activeModule?.slice(1)) || 'Character';
    const fmtD = (d) => (d ? d.split('-').reverse().join('-') : '');
    const dateRange = (sdate || edate)
      ? `Date From: ${fmtD(sdate) || 'All'}    To: ${fmtD(edate) || 'All'}`
      : '';
    exportToExcel({
      title: `${titleLabel} Dashboard`,
      dateRange,
      headers,
      data,
      fileName: `${titleLabel}_Dashboard`,
      sheetName: `${titleLabel} Dashboard`,
    });
  }

  return (
  
    <div className="module-container card-upgrade" style={{ padding: '20px' }}>
      <div className="table-header-title">
        <h3>
                {activeModule?.charAt(0).toUpperCase() + activeModule?.slice(1)} Dashboard 
        </h3>
        <button
          className="btn-excel-export"
          onClick={handleExcelExport}
          title="Download Excel"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM8.5 18l-2-3h1.2l1.3 2 1.3-2H11.5l-2 3 2.2 3H10.3l-1.3-2-1.3 2H6.3l2.2-3zm5 3v-6h1v5h2v1h-3z"/>
          </svg>
          Excel
        </button>
      </div>
      {/* Satyapan Station-Wise Verification Table */}
      <div className="table-wrapper image-styled-table-wrapper">

        
        <table className="image-styled-table">
          <thead>
            {/* <tr>
              <th colSpan="10" style={{ textAlign: 'center', fontSize: '18px', background: '#1e293b', color: '#fff', padding: '12px' }}>
                {activeModule?.charAt(0).toUpperCase() + activeModule?.slice(1)} Dashboard 
              </th>
            </tr> */}
           
            <tr>
              <th>Sr.No.</th>
              <th>Police Station</th>
              <th className={getHighlightClass('all')}>Received</th>
              <th className={getHighlightClass('remain')}>Pending</th>
              <th className={getHighlightClass('ps')}>PS</th>
              <th className={getHighlightClass('dcrb')}>DCRB</th>
              <th className={getHighlightClass('liu')}>LIU</th>
              <th className={getHighlightClass('dcp')}>DCP</th>
              <th className={getHighlightClass('own_to_other')}>Own to Other</th>
              <th className={getHighlightClass('other_to_own')}>Other to Own</th>

            </tr>
          </thead>

          <tbody>
            {loading && (
              <tr><td colSpan="9" style={{ textAlign: 'center', padding: '20px' }}>लोड हो रहा है...</td></tr>
            )}
            {error && (
              <tr><td colSpan="9" style={{ textAlign: 'center', color: 'red' }}>{error}</td></tr>
            )}
            {!loading && stationRows.map((r, i) => (
              <tr key={i} className={i % 2 === 1 ? 'alt-row' : ''}>
                <td>{i + 1}</td>
                <td style={{ fontWeight: '600' }}>{r.pre_station_name }</td>
                <td className={getHighlightClass('all')}>
                  {/* <Link to={`/characters?type=${activeModule}&sdate=${sdate}&edate=${edate}&loc=all&ps=${encodeURIComponent(r.pre_station_code || r.pre_station_name || '')}`}>{r.request_count || 0}</Link> */}
                  {r.request_count || 0} 
                </td>
                <td className={getHighlightClass('remain')}>
                  <Link to={`/characters?type=${activeModule}&sdate=${sdate}&edate=${edate}&loc=remain&ps=${encodeURIComponent(r.pre_station_code || r.pre_station_name || '')}`}>
                    {r.pending_count || r.c_remain || 0}
                  </Link>
                </td>
                <td className={getHighlightClass('ps')}>
                  <Link to={`/characters?type=${activeModule}&sdate=${sdate}&edate=${edate}&loc=ps&ps=${encodeURIComponent(r.pre_station_code || r.pre_station_name || '')}`}>
                    {r.pending_ps_count || r.c_station || 0}
                  </Link>
                </td>
                <td className={getHighlightClass('dcrb')}>
                  <Link to={`/characters?type=${activeModule}&sdate=${sdate}&edate=${edate}&loc=dcrb&ps=${encodeURIComponent(r.pre_station_code || r.pre_station_name || '')}`}>
                    {r.pending_dcrb_count || r.c_dcrb || 0}
                  </Link>
                </td>
                <td className={getHighlightClass('liu')}>
                  <Link to={`/characters?type=${activeModule}&sdate=${sdate}&edate=${edate}&loc=liu&ps=${encodeURIComponent(r.pre_station_code || r.pre_station_name || '')}`}>
                    {r.pending_liu_count || r.c_liu || 0}
                  </Link>
                </td>
                <td className={getHighlightClass('dcp')}>
                  <Link to={`/characters?type=${activeModule}&sdate=${sdate}&edate=${edate}&loc=dcp&ps=${encodeURIComponent(r.pre_station_code || r.pre_station_name || '')}`}>
                    {r.pending_dcp_count || r.c_dcp || 0}
                  </Link>
                </td>
                <td className={getHighlightClass('own_to_other')}>
                  <Link to={`/characters?type=${activeModule}&sdate=${sdate}&edate=${edate}&loc=own_to_other&ps=${encodeURIComponent(r.pre_station_code || r.pre_station_name || '')}`}>
                    {r.own_to_other || r.c_own_to_other || 0}
                  </Link>
                </td>
                 <td className={getHighlightClass('other_to_own')}>
                  <Link to={`/characters?type=${activeModule}&sdate=${sdate}&edate=${edate}&loc=other_to_own&ps=${encodeURIComponent(r.pre_station_code || r.pre_station_name || '')}`}>
                    {r.other_to_own || r.c_other_to_own || 0}
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
